module.exports = __webpack_public_path__ + "static/media/IMG_20191204_125503.99bc16ef.jpg";